// - - - - - - - - - -
// crewVisibility — which crews the grid shows (#703, Leland 2026-10-16).
//
// Two rules, applied once to the crew list every screen reads (modelCx.context.js):
//   1. A record with NO payroll number is never shown. It can't be assigned a job (a job's
//      installer IS a payroll number), and it rendered as a "0000000" crew that is OFF
//      every day — OCO's delivery drivers.
//   2. A Delivery-only record (RecordType "Delivery") is shown only when the user's crew
//      filter has Delivery on. Set per user on Users.defaultFilters.crewFilters[4]; an
//      older 4-item array (no Delivery entry) reads as "shown".
//
// The other crew-type boxes (Detailer / Installer / Helper / Employee) and the crew
// surface boxes are NOT applied here — they have been display-only since the Realm
// context was retired, and switching them on is #704's job.
// - - - - - - - - - -
import { FILTERS_CREW_ARRAY, FILTERS_CREW_DELIVERY } from "./keys";

/** A saved crewFilters array at the current length: missing entries → shown (true). */
export function normalizeCrewFilters(crewFilters) {
  const src = Array.isArray(crewFilters) ? crewFilters : [];
  return FILTERS_CREW_ARRAY.map((_, i) => (typeof src[i] === "boolean" ? src[i] : true));
}

export function isNoPayrollCrew(candidate) {
  return !String(candidate?.payrollNo ?? "").trim();
}

/** RecordType holds one or more types (Recruiter separates them with returns). */
export function isDeliveryOnlyCrew(candidate) {
  const types = String(candidate?.RecordType ?? "")
    .split(/[\r\n,]+/)
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);
  return types.length > 0 && types.every((t) => t === "delivery");
}

/** The crews the grid shows for this user's crew filter. Same array back when nothing is hidden. */
export function visibleCrews(candidates, crewFilters) {
  if (!Array.isArray(candidates)) return candidates;
  const showDelivery = normalizeCrewFilters(crewFilters)[FILTERS_CREW_DELIVERY];
  const out = candidates.filter((c) => !isNoPayrollCrew(c) && (showDelivery || !isDeliveryOnlyCrew(c)));
  return out.length === candidates.length ? candidates : out;
}
